/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import { put, call, takeEvery } from "redux-saga/effects";
import { Resources } from "../api/agent";
import {
  GET_RESOURCES,
  GET_RESOURCES_FAILURE,
  GET_RESOURCES_SUCCESS,
  RESERVE_RESOURCE_SUCCESS,
  RESERVE_RESOURCE_FAILURE,
  RESERVE_RESOURCE,
  POST_RESOURCE_SUCCESS,
  POST_RESOURCE_FAILURE,
  POST_RESOURCE,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAILURE,
  UPLOAD_FILE,
  GET_MY_RESOURCES_SUCCESS,
  GET_MY_RESOURCES_FAILURE,
  GET_MY_RESOURCES,
  GET_VIEW_RESOURCE,
  GET_VIEW_RESOURCE_FAILURE,
  GET_VIEW_RESOURCE_SUCCESS
} from "../actions/actionTypes";

import showToast from "../helpers/toastNotification";

function* getResources(action) {
  try {
    const payload = yield call(Resources.getResources, action.payload);
    yield put({ type: GET_RESOURCES_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: GET_RESOURCES_FAILURE, errResp });
  }
}

export function* watchGetResources() {
  yield takeEvery(GET_RESOURCES, getResources);
}

function* reserveResource(action) {
  try {
    const payload = yield call(Resources.reserveResource, action.payload);
    yield put({ type: RESERVE_RESOURCE_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: RESERVE_RESOURCE_FAILURE, errResp });
  }
}

export function* watchReserveResource() {
  yield takeEvery(RESERVE_RESOURCE, reserveResource);
}

function* getResourceStats(action) {
  try {
    const payload = yield call(Resources.getResourceStats, action.payload);
    yield put({ type: "GET_RESOURCE_STATS_SUCCESS", payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: "GET_RESOURCE_STATS_FAILURE", errResp });
  }
}

export function* watchGetResourceStats() {
  yield takeEvery("GET_RESOURCE_STATS", getResourceStats);
}

/* POST RESOURCE */

function* postResource(action) {
  try {
    const payload = yield call(Resources.postResource, action.payload);
    yield put({ type: POST_RESOURCE_SUCCESS, payload });
    showToast("s", "Resource is posted for review");
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: POST_RESOURCE_FAILURE, errResp });
    showToast("e", "Error while posting resource");
  }
}

export function* watchPostResource() {
  yield takeEvery(POST_RESOURCE, postResource);
}

//   UPLOAD_FILE

function* uploadFile(action) {
  try {
    const payload = yield call(Resources.uploadFile, action.payload);
    yield put({ type: UPLOAD_FILE_SUCCESS, payload });
  } catch (error) {
    const errResp = { message: "Error while uploading image" };
    yield put({ type: UPLOAD_FILE_FAILURE, errResp });
  }
}

export function* watchUploadFile() {
  yield takeEvery(UPLOAD_FILE, uploadFile);
}

function* getMyResourceStats(action) {
  try {
    const payload = yield call(Resources.getMyResourceStats, action.payload);
    yield put({ type: "GET_MY_RESOURCE_STATS_SUCCESS", payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: "GET_MY_RESOURCE_STATS_FAILURE", errResp });
  }
}

export function* watchGetMyResourceStats() {
  yield takeEvery("GET_MY_RESOURCE_STATS", getMyResourceStats);
}

function* getMyResources(action) {
  try {
    const payload = yield call(Resources.getMyResources, action.payload);
    yield put({ type: GET_MY_RESOURCES_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: GET_MY_RESOURCES_FAILURE, errResp });
  }
}

export function* watchGetMyResources() {
  yield takeEvery(GET_MY_RESOURCES, getMyResources);
}

//GETTING SINGLE RESOURCE

function* getViewResource(action) {
  try {
    const payload = yield call(Resources.getViewResource, action.payload);
    yield put({ type: GET_VIEW_RESOURCE_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: GET_VIEW_RESOURCE_FAILURE, errResp });
  }
}

export function* watchGetViewResource() {
  yield takeEvery(GET_VIEW_RESOURCE, getViewResource);
}
